import { AppBar, Box, IconButton, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { useSidebarStore } from '@/stores/useSidebarStore';
import logoLight from '@/assets/images/logo-light.svg';
import pathwayIcon from '@/assets/images/pathway-icon.png';

export function AppLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { mobileOpen, setMobileOpen } = useSidebarStore();

  const handleMenuToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {isMobile && (
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: 'background.paper',
            color: 'text.primary',
          }}
        >
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            <IconButton
              color="inherit"
              aria-label="toggle drawer"
              edge="start"
              onClick={handleMenuToggle}
            >
              <MenuIcon />
            </IconButton>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                component="img"
                src={pathwayIcon}
                alt="Pathway Logo"
                sx={{ height: 28 }}
              />
              <Box
                component="img"
                src={logoLight}
                alt="OC&C Logo"
                sx={{ height: 28 }}
              />
            </Box>
          </Toolbar>
        </AppBar>
      )}
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          p: { xs: 2, md: 3 },
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 2, md: 3 },
          transition: 'margin-left 225ms cubic-bezier(0.4, 0, 0.6, 1)',
          ...(isMobile && { mt: 8 }), // Add top margin on mobile to account for AppBar
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default AppLayout;